module.exports = __webpack_public_path__ + "c16b6dbe7371956606c4e7f251207fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/order_redisign.png
// module id = 472
// module chunks = 0